<div [style.background]=" _active ? 'skyblue' : ''">
  <ng-content>
  </ng-content>
</div>
